import axios from 'axios';
import { config } from '../../Configs';

export const GeneratePrepaidMeterCouponAPI = async (
  authToken,
  requestId,
  origin
) => {
  try {
    const configObj = { headers: { Authorization: authToken } };

    const response = await axios.post(
      `${config.api.url}/prepaid-meter/generate-coupon/${requestId}`,
      { origin },
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const CalculateRechargeAPI = async (authToken, value, meterSerial) => {
  try {
    const configObj = { headers: { Authorization: authToken } };

    const response = await axios.post(
      `${config.api.url}/prepaid-meter/calculate-recharge`,
      { value, meterSerial },
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const ConfirmRechargeAPI = async (authToken, requestId) => {
  try {
    const configObj = { headers: { Authorization: authToken } };

    const response = await axios.post(
      `${config.api.url}/prepaid-meter/confirm-recharge/${requestId}`,
      {},
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const CheckPendingRechargeAPI = async (authToken, meterSerial) => {
  try {
    const configObj = { headers: { Authorization: authToken } };

    const response = await axios.post(
      `${config.api.url}/prepaid-meter/check-pending-recharge`,
      { meterSerial },
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const CompleteRechargeAPI = async (authToken, requestId) => {
  try {
    const configObj = { headers: { Authorization: authToken } };

    const response = await axios.post(
      `${config.api.url}/prepaid-meter/${requestId}/complete`,
      {},
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};
